import { render, staticRenderFns } from "./AppShopFilters.vue?vue&type=template&id=127f204a"
import script from "./AppShopFilters.vue?vue&type=script&lang=ts"
export * from "./AppShopFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports